/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  ClientMenu,
  SecondaryNavCustomer,
} from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import {
  EditOutlined,
  DeleteTwoTone,
  InfoCircleTwoTone,
  CheckCircleTwoTone,
  CheckOutlined,
  PlusOutlined,
  CloseOutlined,
  MinusOutlined,
} from "@ant-design/icons";
// eslint-disable-next-line no-unused-vars
import { Table, Button, Tag, Spin, Select, Popconfirm, Popover } from "antd";
import "../formStyles.css";
import moment from "moment";
import UsersTable from "../../../components/AdminComponents/UsersTable";
import { Form, Input, DatePicker, Modal } from "antd";
import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import EditableImage from "../../../components/icons/EditIcon";
import EditSub from "../../../components/AdminComponents/Modals/EditSub";
import { message } from "antd";
import EditSubRow from "../../../components/AdminComponents/Modals/EditSubRow";
import SubscriptionDeleteModal from "../../../components/AdminComponents/Modals/SubscriptionDeleteModal";
import AddSub from "../../../components/AdminComponents/Modals/AddSub";
import {
  capitalizeWords,
  ModuleColor,
  truncateText,
} from "../../../components/icons/ApplicationColor";
import { getUpdateStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import { GetFormattedDate } from "../../../components/utils/DateTimeUtils";
import DetailsContainer from "../../../components/DetailsContainer";

const { Option } = Select;
const { RangePicker } = DatePicker;

// import React, { useState } from "react";
// import { Table, Button } from "antd";

// eslint-disable-next-line no-unused-vars
const columns = [
  {
    title: "Products",
    dataIndex: "products",
    key: "products",
    width: 200,
    render: (tag) => {
      return (
        <Tag color="volcano">
          <span className="tag-container">{tag}</span>
        </Tag>
      );
    },
  },
  {
    title: "Billing",
    dataIndex: "billing",
    key: "billing",
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    key: "startDate",
  },
  {
    title: "End Date",
    dataIndex: "endDate",
    key: "endDate",
  },
];
function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
const renderStatus = (text, record) => {
  if (record.status) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "1.8rem",
            height: "1.8rem",
            borderRadius: "50%",
            backgroundColor: "#52c41a",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CheckOutlined
            style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "1.8rem",
            height: "1.8rem",
            borderRadius: "50%",
            backgroundColor: "#ff4d4f",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CloseOutlined
            style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
          />
        </div>
      </div>
    );
  }
  // else {
  //   return text;
  // }
};

const CustomerSub = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  //console.log(id);
  const userInfo = useSelector((state) => state.user);
  const namingData = useSelector((state) => state.orgdeatil);
  //console.log(namingData);
  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const handleRowClick = (recordId) => {
    // Check if the recordId is already in the expandedRowKeys state
    const isExpanded = expandedRowKeys.includes(recordId.id);

    // Create a new array of expandedRowKeys based on the current state
    let updatedRowKeys = [...expandedRowKeys];

    if (isExpanded) {
      // If the recordId is already expanded, remove it from the array
      updatedRowKeys = updatedRowKeys.filter((id) => id !== recordId.id);
    } else {
      // If the recordId is not expanded, add it to the array
      updatedRowKeys.push(recordId.id);
    }

    // Update the expandedRowKeys state with the new array
    setExpandedRowKeys(updatedRowKeys);
    //console.log(expandedRowKeys);
  };

  const checkIltEnable = (record) => {
    if (record.ilt_enabled === true) {
      return true;
    } else {
      return false;
    }
  };

  const handleCancel = (recordId) => {
    // Remove the specific recordId from the expandedRowKeys state
    const updatedRowKeys = expandedRowKeys.filter((id) => id !== recordId);
    setExpandedRowKeys(updatedRowKeys);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const showModalDelete = () => {
    setIsModalVisible(true);
  };

  const handleCancelDelete = () => {
    setIsModalVisible(false);
  };
  const checkDelete = (record) => {
    if (record?.can_be_deleted?.delete) {
      handleDelete(record);
    } else {
      //console.log("coming here");
      setSelectedRecord(record);
      setIsModalVisible(true);
    }
  };
  const handleDelete = async (record) => {
    try {
      const res = await Axios.delete(`/orgsubscription/${record.id}/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      LoadApplications();
      setIsModalVisible(false);
      CreateSuccessfull("deleted");
    } catch (err) {
      //console.log(err);
      CreateFailed("deleted");
    }
  };
  const columns2 = [
    {
      title: "MODULES",
      dataIndex: "application",
      key: "application",
      align: "center",
      render: (application) => {
        return (
          <Tag
            color={ModuleColor(application)}
            style={{
              minWidth: "15rem",
              textAlign: "center",
              maxWidth: "18rem",
              minHeight: "3rem",
            }}
          >
            <span
              className="tag-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                lineHeight: "3rem",
              }}
            >
              {application}
            </span>
          </Tag>
        );
      },
    },
    {
      title: "CONTRACT ID",
      dataIndex: "contract_id",
      key: "contract_id",
    },
    // {
    //   title: "ENROLLMENT TYPE",
    //   dataIndex: "enrollment_type",
    //   key: "enrollment_type",
    // },
    {
      title: "BILLING",
      dataIndex: "billing_cycle",
      key: "billing",
    },

    {
      title: "CATEGORY",
      dataIndex: "subscription_category",
      key: "subscription_category",
    },

    {
      title: "START DATE",
      dataIndex: "start_date",
      key: "start_date",
      editable: true,
      render: GetFormattedDate,
    },
    {
      title: "END DATE",
      dataIndex: "end_date",
      key: "end_date",
      editable: true,
      render: GetFormattedDate,
    },
    // {
    //   title: "PRODUCTS",
    //   dataIndex: "products",
    //   key: "products",
    //   render: (applications) => (
    //     <span>
    //       {applications.map((tag, index) => {
    //         let color;

    //         if (tag.name === "CO") {
    //           color = "orange";
    //         } else if (tag.name === "JDV2") {
    //           color = "blue";
    //         } else {
    //           color = "red";
    //         }
    //         return (
    //           <Tag
    //             color={color}
    //             key={index}
    //             title={tag.description}
    //             style={{ cursor: "pointer" }}
    //           >
    //             <span style={{ color: "black", fontWeight: "500" }}>
    //               {tag.name}
    //             </span>
    //           </Tag>
    //         );
    //       })}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Active",
    //   dataIndex: "status",
    //   key: "status",
    //   render: renderStatus,
    // },
    ...(false
      ? [
          {
            title: "ACTIONS",
            key: "actions",
            render: (text, record) => {
              return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {/* <DeleteTwoTone onClick={handleClick(record)} /> */}
                  <EditableImage
                    handleRowClick={handleRowClick}
                    recordId={record}
                  />
                  <Popconfirm
                    title="Delete Subscription"
                    description=" "
                    onConfirm={() => checkDelete(record)}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.8rem",
                        marginLeft: "0.9rem",
                      }}
                      // onClick={() => {
                      //   handleDelete(record);
                      // }}
                      title="delete"
                      twoToneColor="#eb2f96"
                    />
                  </Popconfirm>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  // eslint-disable-next-line no-unused-vars
  const [newProduct, setNewProduct] = useState(false);
  const [applications, setApplications] = useState([]);
  const [enrollments, SetEnrollments] = useState([]);
  const [category, setCategory] = useState([]);
  const [categoryType, setCategoryType] = useState([]);
  const [subscription, setSubscription] = useState([]);
  const [billings, setBillings] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(true);
  const formRef = useRef();
  const handleReset = () => {
    formRef.current.resetFields();
  };
  const LoadUser2 = async () => {
    try {
      const res = await Axios.get(`/orgsubscriptionlist/${id}/`);
      //console.log(res.data);
      setData2(res.data);
      setLoading(false);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadOtherData = () => {
    LoadSubscriptions();
    LoadCategory();
    LoadBillings();
    LoadEnrollments();
    // LoadCategory();
    // LoadSubscriptions();
  };

  const LoadApplications = async () => {
    //console.log(id);
    try {
      const res = await Axios.get(`/nonorgproducts/${id}/`);
      //console.log(res.data);
      setApplications(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadEnrollments = async () => {
    try {
      const res = await Axios.get("/options/enrollment_type");
      //console.log(res.data);
      SetEnrollments(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadSubscriptions = async () => {
    try {
      const res = await Axios.get("/options/subscription_type/");
      //console.log(res.data);
      setSubscription(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadBillings = async () => {
    try {
      const res = await Axios.get("/options/billing_cycle");
      //console.log(res.data);
      setBillings(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadCategory = async () => {
    try {
      const res = await Axios.get("/options/subscription_category/");
      //console.log(res.data);
      setCategory(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadCategoryType = async () => {
    try {
      const res = await Axios.get("/options/contract_type/");
      //console.log(res.data);
      setCategoryType(res.data);
    } catch (err) {
      //console.log(err);
    }
  };

  useEffect(() => {
    LoadUser2();
    LoadApplications();
    LoadSubscriptions();
    LoadCategory();
    LoadBillings();
    LoadEnrollments();
    LoadCategoryType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const onFinish = async (values, event) => {
    const { dateRange, ...otherValues } = values;

    const filteredValues = Object.fromEntries(
      Object.entries(otherValues).filter(([_, value]) => value !== undefined)
    );

    const startDate = dayjs(dateRange[0]);
    const endDate = dayjs(dateRange[1]);
    //console.log(dateRange[0]);

    const payload = {
      ...filteredValues,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
      organization: parseInt(id, 10),
    };

    //console.log(payload);
    try {
      const res = await Axios.post("/orgsubscriptioncreate/", payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull("created");
    } catch (err) {
      //console.log(err);
      CreateFailed("created");
    }
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Subscription has been ${props}.`,
      duration: 5,
    });
    setNewProduct(false);
    setLoading(true);
    LoadUser2();
    if (props === "created") {
      handleReset();
    } else {
      setExpandedRowKeys([]);
    }
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Subscription has not been ${props}.`,
      duration: 5,
    });
  };
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const confirm = (e) => {
    //console.log(e);
    message.success("Click on Yes");
  };
  const cancel = (e) => {
    //console.log(e);
    message.error("Click on No");
  };
  const expandIcon = ({ expanded, onExpand, record }) =>
    expanded ? (
      <MinusOutlined
        onClick={(e) => {
          handleCancel(record.id);
          //console.log(record);
        }}
      />
    ) : (
      <PlusOutlined
        onClick={(e) => {
          handleRowClick(record);
          //console.log(record);
        }}
      />
    );
  const [addnewModal, setAddnewModal] = useState(false);
  const addModalReturn = (value) => {
    setAddnewModal(false);
    if (value) {
      LoadApplications();
      CreateSuccessfull("Created");
    } else {
      CreateFailed("Creation");
    }
  };
  const details = [
    {
      label: "Parent Client ID",
      value: namingData?.customer_client_id,
    },
    {
      label: "Parent Client Name",
      value: namingData?.customer_client_name,
    },
    { label: "Customer ID", value: namingData.id },
    { label: "Customer Name", value: namingData.name },
  ];
  return (
    <Sidebar props={ClientMenu}>
      {contextHolder}
      <SecondaryNav id={parseInt(id)} menuItems={SecondaryNavCustomer} />
      <div className="form-container-2">
        <DetailsContainer details={details} />
        <Spin spinning={loading}>
          <div className="sub-box-conatiner">
            <div className="subscription-box">
              <div className="sub-header">
                <h2 className="sub-text">
                  {capitalizeWords("Subscription Details")}
                </h2>
                {applications.length > 0 && false && (
                  <>
                    {" "}
                    <Button
                      type="primary"
                      htmlType="button"
                      style={{
                        marginRight: "4rem",
                        marginTop: "2rem",
                      }}
                      className="small-add-btn"
                      onClick={() => {
                        // setNewProduct((prev) => !prev);
                        // setExpandedRowKeys([]);
                        setAddnewModal(true);
                        // LoadOtherData();
                      }}
                    >
                      + Add
                    </Button>
                  </>
                )}
              </div>
              <AddSub
                visible={addnewModal}
                // iltEnable = {checkIltEnable(record)}
                addModalReturn={addModalReturn}
                handleCancel={() => setAddnewModal(false)}
                applications={applications}
                subscription={subscription}
                category={category}
                enrollments={enrollments}
                billings={billings}
                categoryType={categoryType}
                namingData={namingData}
              />
              <Table
                dataSource={data2}
                columns={columns2}
                pagination={false}
                className="sub-table"
                rowKey="id"
                // size="small"
                scroll={{
                  x: 1000,
                }}
                style={{ margin: "2rem" }}
                // expandedRowKeys={expa ndedRowKeys}
                // expandIconColumnIndex={-1}

                expandable={
                  false && {
                    expandIcon: expandIcon,
                    expandedRowKeys: expandedRowKeys,
                    expandedRowRender: (record) => (
                      <EditSubRow
                        key={record.id}
                        record={record}
                        setExpandedRowKeys={setExpandedRowKeys}
                        CreateSuccessfull={CreateSuccessfull}
                        CreateFailed={CreateFailed}
                        subscription={subscription}
                        category={category}
                        enrollments={enrollments}
                        billings={billings}
                        handleCancel={handleCancel}
                        categoryType={categoryType}
                      />
                    ),
                  }
                }
              />
              <SubscriptionDeleteModal
                recordData={selectedRecord}
                isVisible={isModalVisible}
                onCancel={handleCancelDelete}
                onConfirm={handleDelete}
              />
              <EditSub
                key={modalData?.id}
                record={modalData}
                visible={visible}
                onCancel={handleCancel}
                CreateSuccessfull={CreateSuccessfull}
                CreateFailed={CreateFailed}
                subscription={subscription}
                category={category}
                enrollments={enrollments}
                billings={billings}
                categoryType={categoryType}
              />
              {newProduct && (
                <div
                  style={{
                    marginLeft: "6rem",
                    marginBottom: "2rem",
                    width: "100%",
                  }}
                >
                  <Form layout="inline" onFinish={onFinish} ref={formRef}>
                    <Form.Item name="application" style={{ flex: 1.2 }}>
                      <Select
                        placeholder="Select application"
                        name="application"
                      >
                        {applications?.map((app) => (
                          <Option key={app.id} value={app.id}>
                            {app.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="contract_id"
                      style={{ flex: 1 }}
                      rules={[
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only",
                        },
                      ]}
                    >
                      <Input placeholder="Contract_id" name="contractID" />
                    </Form.Item>

                    <Form.Item name="billing_cycle" style={{ flex: 0.7 }}>
                      <Select placeholder="Billing" name="billing_cycle">
                        {billings?.billing_cycle?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="subscription_type" style={{ flex: 1 }}>
                      <Select
                        placeholder="Subscription Type"
                        name="subscription_type"
                      >
                        {subscription?.subscription_type?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="subscription_category"
                      style={{ flex: 0.7 }}
                    >
                      <Select
                        placeholder="Category"
                        name="subscription_category"
                      >
                        {category?.subscription_category?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="dateRange" style={{ flex: 2 }}>
                      <RangePicker
                        placeholder={["Start Date", "End Date"]}
                        name="dateRange"
                      />
                    </Form.Item>
                    <Form.Item style={{ flex: 1 }}>
                      <div>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{
                            background: "transparent",
                            border: "none",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "1.8rem",
                                height: "1.8rem",
                                borderRadius: "50%",
                                backgroundColor: "#52c41a",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CheckOutlined
                                title="submit"
                                style={{
                                  color: "#fff",
                                  fontSize: "1.2rem",
                                  fontWeight: "700",
                                }}
                              />
                            </div>
                          </div>
                        </Button>

                        <DeleteTwoTone
                          style={{
                            cursor: "pointer",
                            fontSize: "1.7rem",
                            marginLeft: "0.9rem",
                          }}
                          title="delete"
                          twoToneColor="#eb2f96"
                          onClick={() => {
                            setNewProduct(false);
                            handleReset();
                          }}
                        />
                      </div>
                    </Form.Item>
                  </Form>
                </div>
              )}
            </div>
          </div>
          {/* <UsersTable data={record} /> */}
        </Spin>
      </div>
    </Sidebar>
  );
};

export default CustomerSub;
